export const SET_NAV_CONTENT = "set_nav_content";